import React from 'react';
import {AxiosError} from 'axios';
import {ApiError, ApiErrorIntent} from '@mc/axios-api';
import {SubmissionError} from "redux-form";
import {toastr} from "react-redux-toastr";

/**
 * Robrazit toastr..
 *
 * @param error chyba
 * @param defaultIntent pokud není určen, bude použit tento
 * @param apiIntent intent z api, nemusí být uveden, pak je použit defaultIntent
 */
const showToastr = (error: ApiError, defaultIntent: ApiErrorIntent, apiIntent?: ApiErrorIntent): void => {

    const label = error.messageTitle;

    let finalIntent : ApiErrorIntent | undefined = apiIntent;
    if (apiIntent != ApiErrorIntent.DANGER && apiIntent != ApiErrorIntent.WARNING) {
        finalIntent = defaultIntent;
    }

    let showToastr;
    const toastrProps = {} as {
        timeOut?: number,
        removeOnHover?: boolean
    };
    switch (finalIntent) {
        case ApiErrorIntent.DANGER:
            showToastr = toastr.error;
            toastrProps.timeOut = 30000;
            toastrProps.removeOnHover = false;
            break;
        case ApiErrorIntent.WARNING:
            showToastr = toastr.warning;
            toastrProps.timeOut = 30000;
            toastrProps.removeOnHover = false;
            break;
    }

    if (error.messageDesc) {
        toastrProps.timeOut = 30000;
        toastrProps.removeOnHover = false;
        // @ts-ignore
        toastrProps.component = <div>
            {error.messageDesc}
        </div>
    }

    showToastr(label, toastrProps);
};

export const uniStandardErrorInterceptor = (_error: any | AxiosError): any => {
    if (_error.stack && _error.message) {
        console.error(_error);
        toastr.error(_error.message);
        return Promise.reject(_error);
    } else {
        const error = _error as ApiError;
        switch (error.status) {
            case 422: {
                throw new SubmissionError(error.formErrors);
            }
            default: {
                toastr.warning
                showToastr(error, ApiErrorIntent.DANGER, error.errorIntent);
                return Promise.reject(error);
            }
        }
    }
};
